(function () {
  const FEE_VARIANT_ID = 48479424774465;

  // ✅ Déjalo en true para probar HOY. Cuando todo funcione, ponlo en false.
  const TEST_MODE = false;

  const TZ = "Europe/Zurich";
  const START_HOUR = 0;      // ✅ 00:00 (12:00 am)
  const START_MINUTE = 0;
  const END_HOUR = 15;
  const END_MINUTE = 0;

  function getZurichParts(date = new Date()) {
    const dtf = new Intl.DateTimeFormat("en-GB", {
      timeZone: TZ,
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    });
    return dtf.formatToParts(date).reduce((acc, p) => {
      acc[p.type] = p.value;
      return acc;
    }, {});
  }

  function isAllowedNow() {
  if (TEST_MODE) return true;

  const p = getZurichParts();
  const h = parseInt(p.hour, 10);
  const m = parseInt(p.minute, 10);

  // Allowed window:
  // Thu from 15:01 to 23:59
  // Fri from 00:00 to 14:59
  if (p.weekday === "Thu") {
    return (h > 15) || (h === 15 && m >= 1);
  }

  if (p.weekday === "Fri") {
    return (h < 14) || (h === 14 && m <= 59);
  }

  return false;
}


  async function fetchCart() {
    const res = await fetch("/cart.js", { cache: "no-store" });
    return res.json();
  }

  function findFeeLine(cart) {
    return cart.items.find(i => i.variant_id === FEE_VARIANT_ID) || null;
  }

  async function addFee() {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: FEE_VARIANT_ID, quantity: 1 })
    });
  }

  async function removeFee(lineItemKey) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineItemKey, quantity: 0 })
    });
  }

  async function mount() {
    const wrap = document.getElementById("sat-delivery-wrap");
    const cb = document.getElementById("sat-delivery-checkbox");
    if (!wrap || !cb) return; // bloque no está en el cart

    const allowed = isAllowedNow();
    if (!allowed) {
      wrap.style.display = "none";
      return;
    }

    wrap.style.display = "block";

    const cart = await fetchCart();
    const feeLine = findFeeLine(cart);
    cb.checked = !!feeLine;

    cb.onchange = async () => {
      cb.disabled = true;

      const latestCart = await fetchCart();
      const existing = findFeeLine(latestCart);

      if (cb.checked && !existing) {
        await addFee();
        setTimeout(() => location.reload(), 600);
      } else if (!cb.checked && existing) {
        await removeFee(existing.key);
        setTimeout(() => location.reload(), 600);
      } else {
        cb.disabled = false;
      }
    };
  } // ✅ ESTA LLAVE FALTABA EN TU CÓDIGO

  function boot() {
    mount().catch(console.error);
    setTimeout(() => mount().catch(console.error), 500);
    setTimeout(() => mount().catch(console.error), 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
